import { Config } from './config-types';

import cartridges from './config.json';

export function readConfig() {
  return cartridges as any as Config;
}
